import { useEffect, useState } from "react";
import api from "../../services/api";
import socket from "../useSocket";

const isValid = (v) => v === "list" || v === "next";

const usePendingTicketsLogic = () => {
	const [value, setValue] = useState("list");

	useEffect(() => {
		let mounted = true;

		const fetchValue = async () => {
			try {
				const { data } = await api.get("/settings/pending-tickets-logic");
				if (mounted && isValid(data?.pendingTicketsLogic)) {
					setValue(data.pendingTicketsLogic);
				}
			} catch { /* falha silenciosa, próximo trigger refaz */ }
		};

		const handleSettingsUpdate = (data) => {
			if (data?.action === "update" && isValid(data?.setting?.pendingTicketsLogic)) {
				if (mounted) setValue(data.setting.pendingTicketsLogic);
			}
		};

		const handleConnect = () => fetchValue();
		const handleFocus = () => fetchValue();
		const handleOnline = () => fetchValue();
		const handleVisibility = () => {
			if (document.visibilityState === "visible") fetchValue();
		};

		fetchValue();
		socket.on("settings", handleSettingsUpdate);
		socket.on("connect", handleConnect);
		window.addEventListener("focus", handleFocus);
		window.addEventListener("online", handleOnline);
		document.addEventListener("visibilitychange", handleVisibility);

		return () => {
			mounted = false;
			// socket.off("settings", handleSettingsUpdate);
			// socket.off("connect", handleConnect);
			window.removeEventListener("focus", handleFocus);
			window.removeEventListener("online", handleOnline);
			document.removeEventListener("visibilitychange", handleVisibility);
		};
	}, []);

	return value;
};

export default usePendingTicketsLogic;
